module.exports = __webpack_public_path__ + "static/media/exclamation-circle.34181d4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exclamation-circle.svg
// module id = 2058
// module chunks = 33